import React from "react";
import { ProcedureType, TScreen } from "api/type";
import {
  breastAugModels,
  breastLiftModels,
  breastReductionModels,
  tummyTuckModels,
  bblModels,
} from "api/constants";
import { formatProcedureName } from "utils/formatProcedureName";
import {
  TitleBar,
  NormalText,
  SelectModel,
  PoweredByClinicOS,
} from "components/index";
import ScreenContext from "contexts/screen";

type Screen1Props = {
  saveSelectedImageUrlOrBlob: (imageUrlOrBlob: string | Blob) => void;
  procedure: ProcedureType | null;
};

const Screen1: React.FC<Screen1Props> = ({
  saveSelectedImageUrlOrBlob,
  procedure,
}) => {
  const setScreen = React.useContext(ScreenContext)[1];

  const handleSaveImageUrlOrBlob = (imageUrlOrBlob: string | Blob) => {
    saveSelectedImageUrlOrBlob(imageUrlOrBlob);
    setScreen(TScreen.SIMULATION_VIEW_SCREEN);
  };

  const renderSelectModel = (procedure: ProcedureType | null) => {
    let models: string[];

    switch (procedure) {
      case ProcedureType.BREAST_AUGMENTATION:
        models = breastAugModels;
        break;
      case ProcedureType.BREAST_LIFT:
        models = breastLiftModels;
        break;
      case ProcedureType.BREAST_REDUCTION:
        models = breastReductionModels;
        break;
      case ProcedureType.TUMMY_TUCK:
        models = tummyTuckModels;
        break;
      case ProcedureType.BBL:
        models = bblModels;
        break;
      case null:
        return (
          <p style={styles.errorText}>Please pass in a procedure in the url.</p>
        );
      default:
        return (
          <p style={styles.errorText}>
            Your procedure is not supported yet or you passed in an invalid
            input.
          </p>
        );
    }

    return (
      <SelectModel
        imageUrls={models.slice(0, 3).map((modelUrl: string) => modelUrl)}
        handleSaveImageUrlOrBlob={handleSaveImageUrlOrBlob}
      />
    );
  };

  return (
    <div style={styles.container}>
      <TitleBar name={"Select an Image"} onClickBackButton={null} />
      <NormalText
        textContent={`Visualize a ${formatProcedureName(
          procedure,
        )} by selecting an image below.`}
      />
      <div style={styles.spacer} />
      <div style={styles.imagePickerContainer}>
        {renderSelectModel(procedure)}
      </div>
      <PoweredByClinicOS />
    </div>
  );
};

// Styles
const styles = {
  container: {
    display: "flex" as const,
    flexDirection: "column" as const,
    justifyContent: "space-between" as const,
    alignItems: "flex-start" as const,
    height: "100%",
  },
  spacer: {
    marginBottom: 10,
  },
  imagePickerContainer: {
    overflow: "auto" as const,
    padding: "0px 10px",
    marginBottom: "auto",
  },
  errorText: {
    color: "red",
    fontSize: "16px",
  },
};

export default Screen1;
